import React from 'react';
import Gallery from '../components/Gallery/Gallery';
import useAPI from '../hooks/useAPI';

const GalleryPage = () => {
  const {
    data: galleryData,
    loading,
    error,
  } = useAPI('/gallery');

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  console.log('Gallery Data:', galleryData);

  return (
    <div className="pt-20">
      <Gallery data={galleryData?.data} />
    </div>
  );
};

export default GalleryPage;